import { Component, ElementRef, ViewChild, inject } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { PageComponent, FormHandlingComponent, Page, Redirection } from '@tytapp/common';
import { UserService } from '@tytapp/user';
import { ApiMembership, ApiMembershipProduct, ApiPaymentSource, ApiUser, MembershipProductsApi, UsersApi } from 'api';

@Page('changeMembership')
@Component({
  selector: 'app-change-membership',
  templateUrl: './change-membership.component.html',
  styleUrls: ['./change-membership.component.scss']
})
export class ChangeMembershipComponent extends PageComponent implements FormHandlingComponent {
  private route = inject(ActivatedRoute);
  private userService = inject(UserService);
  private redirection = inject(Redirection);
  private userApi = inject(UsersApi);
  private membershipProductsApi = inject(MembershipProductsApi);

  user: ApiUser;
  membership: ApiMembership;
  availableMembershipProducts: ApiMembershipProduct[];
  ready : boolean = false;
  phase : string;
  membershipGrade: number;
  periodChange: boolean = false;
  proratedCost : number = 0;
  newChargeDate : string;
  errorMessage : string = "";
  paypalSub : boolean;
  paymentSource: ApiPaymentSource;

  @ViewChild('mobileActions')
  mobileActionsRef : ElementRef;

  ngAfterViewInit() {
    if (typeof window !== 'undefined' && this.mobileActionsRef && this.mobileActionsRef.nativeElement) {
      let root = document.querySelector('app-root')
      if (root)
        root.appendChild(this.mobileActionsRef.nativeElement);
    }
  }

  destroy() {
    if (this.mobileActionsRef && this.mobileActionsRef.nativeElement) {
      let el : HTMLElement = this.mobileActionsRef.nativeElement;
      el.remove();
    }
  }

  scenario : string = 'no_membership';

  async init() {
    this.phase = 'change';
    this.availableMembershipProducts = await this.membershipProductsApi.all().toPromise();

    this.subscribe(this.userService.userChanged, async user => {
      this.paypalSub = false;
      this.ready = false;
      if (!user) { 
        this.userService.goToLogin();
        return;
      }
      this.user = user;
      this.membership = user.membership;
      this.ready = true;
      this.scenario = this.selectScenario();
    })

    this.subscribe(this.route.queryParamMap, async params => {
      this.productID = Number(params.get('product'));
      this.offerSetID = params.get('offerSet');
    });
    
    try {
      this.paymentSource = await this.userApi.getPaymentSource().toPromise();
    } catch (e) {
      console.error(`Failed to retrieve payment source:`);
      console.error(e);
    }
  }

  scenarios = [
    { id: 'no_membership', label: 'No membership' },
    { id: 'inactive', label: 'Membership expired' },
    { id: 'supported', label: 'Change Supported' },
    { id: 'google_play', label: 'Google Play' },
    { id: 'iap_apple', label: 'Apple IAP' },
    { id: 'youtube', label: 'YouTube' },
    { id: 'paypal_agreement', label: 'PayPal' },
  ];
  
  selectScenario() {
    if (!this.membership)
      return 'no_membership';
      
    if (!this.membership.active)
      return 'inactive';
    
    let unsupportedGateways = ['google_play', 'iap_apple', 'youtube', 'paypal_agreement', 'paypal_subscription'];
    if (unsupportedGateways.includes(this.membership.gateway_name))
      return this.membership.gateway_name;

    return 'supported';
  }

  async submit() {

  }

  get membershipIsAnnual() {
    return (this.user && this.user.membership) ? this.user.membership.annual : false;
  }

  capitalizeFirstLetter(string) {
    return string.charAt(0).toUpperCase() + string.slice(1);
  }

  toPrevious() {
    this.redirection.go('/settings/memberships');
  }

  shortPeriod(period) {
    return period === 'monthly' ? '/mo' :
      period === 'annually' ? '/yr' :
      ` ${this.capitalizeFirstLetter(period)}`
    ;
  }

  productID : number;
  offerSetID : string;

  get selectedProduct(): ApiMembershipProduct {
    if (!this.productID && this.user && this.user.membership && this.user.membership.product)
      return this.user.membership.product;

    if (!this.availableMembershipProducts)
      return null;

    return this.availableMembershipProducts.find(x => x.id === this.productID);
  }

  isCurrent(plan : ApiMembershipProduct) {
    if (!this.membership || !this.membership.product || !plan)
      return false;
    return this.membership.product.id === plan.id;
  }

  formatPeriod(period : string) {
    return period.slice(0, 1).toUpperCase() + period.slice(1);
  }
}
